import React, { useEffect, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import FilterMenu from "../../components/Layout/FilterMenu";
import { ButtonDelete, ButtonEditRow } from "../../components/common/Buttons";
import TableFilterBox from "../../components/common/TableFilterBox";
import ContentValidation from "../../components/common/ContentValidation";
import {
  SelectInput,
  TextInput,
  ButtonSecondary,
} from "../../components/globals";
import TableUi from "../../components/Layout/TableUI";
import { Button, Form, Input, Select } from "antd";
import { handleKeyDown2 } from "../../helpers/FunctionsGlobal";
import { IconPixelArt } from "../../components/Layout/Icons";
import { useModal, useFetch } from "../../hooks";
import ModalSimple from "../../components/Layout/Modals/ModalSimple";
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import Axios from "axios";
import { antdMessageError, antdMessageSuccess } from "../../helpers/Utils";

const queryClient = new QueryClient();

function PaymentMethodGroupsPage({ match }) {
  return (
    <QueryClientProvider client={queryClient}>
      <PaymentMethodGroupsScreen match={match} />
    </QueryClientProvider>
  );
}
export default PaymentMethodGroupsPage;

function PaymentMethodGroupsScreen({ match }) {
  const [carriers, setCarriers] = useState([]);
  const { modalOpt, setModalOpt, closeModal } = useModal();
  const [groupData, setGroupData] = useState([]);
  const [selectedPaymentType, setSelectedPaymentType] = useState([]);
  const [groupNameFilter, setGroupNameFilter] = useState("");

  const {
    value: valuePaymentGroups,
    loading: loadingPaymentGroups,
    setReFetch: setReFetchPaymentGroups,
  } = useFetch(`/api/v1/payment_groups`);

  const {
    value: valuePaymentTypes,
    loading: loadingPaymentTypes,
    setReFetch: setReFetchPaymentTypes,
  } = useFetch(`/api/v1/payment_types`);

  const mutationDelete = useMutation({
    mutationFn: (id) =>
      Axios({
        url: `/api/v1/payment_groups/${id}`,
        method: "DELETE",
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      setReFetchPaymentGroups();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  const clearFilter = () => {
    setGroupNameFilter("");
    setSelectedPaymentType([]);
    setGroupData(valuePaymentGroups?.data || []);
  };

  const onFilter = () => {
    let filteredData = valuePaymentGroups?.data || [];

    if (groupNameFilter.trim()) {
      filteredData = filterByTitle(filteredData, groupNameFilter);
    }

    if (selectedPaymentType && selectedPaymentType.length > 0) {
      filteredData = filterByPaymentType(filteredData, selectedPaymentType);
    }

    setGroupData(filteredData);
  };

  function filterByTitle(data, title) {
    return data.filter((item) =>
      item.title.toLowerCase().includes(title.toLowerCase())
    );
  }

  function filterByPaymentType(data, selectedTypes) {
    return data.filter((item) =>
      item.payments.some((payment) => selectedTypes.includes(payment.id))
    );
  }

  const getFilteredData = () => {
    let filteredData = valuePaymentGroups?.data || [];

    if (groupNameFilter.trim()) {
      filteredData = filteredData.filter((item) =>
        item.title.toLowerCase().includes(groupNameFilter.toLowerCase())
      );
    }

    if (selectedPaymentType && selectedPaymentType.length > 0) {
      filteredData = filteredData.filter((item) =>
        item.payments.some((payment) =>
          selectedPaymentType.includes(payment.id)
        )
      );
    }

    return filteredData;
  };

  useEffect(() => {
    setReFetchPaymentGroups();
  }, [modalOpt]);

  useEffect(() => {
    if (valuePaymentGroups?.data) {
      setGroupData(valuePaymentGroups.data);
      onFilter();
    }
  }, [valuePaymentGroups]);

  return (
    <QueryClientProvider client={queryClient}>
      <Container
        location={{
          locationName: "Payment method groups",
          locationUrl: match.url,
        }}
      >
        <ContentBlock>
          <FilterMenu
            length={groupData.length || 0}
            iconComponent={<IconPixelArt />}
            text2="types"
          />
        </ContentBlock>

        <ContentBlock>
          <TableFilterBox
            filter={true}
            onFilter={() => onFilter()}
            clearFilter={() => clearFilter()}
            button1={
              <>
                <div
                  className="float-left ml-2"
                  style={{
                    width: 104,
                  }}
                >
                  <ButtonSecondary onClick={() => setModalOpt("new_group", 1)}>
                    New group
                  </ButtonSecondary>
                </div>
              </>
            }
          >
            <div className="px-1 d-flex">
              <div>
                <TextInput
                  text="Group name"
                  name={groupNameFilter}
                  value={groupNameFilter || ""}
                  onKeyDown={handleKeyDown2(onFilter)}
                  onChange={(val) => {
                    const value = val.target.value;
                    setGroupNameFilter(value);
                  }}
                />
              </div>
              <div className="ml-2 w-200">
                <SelectInput
                  mode={"multiple"}
                  label="Method of payment"
                  options={valuePaymentTypes?.data?.map((paymentType) => ({
                    value: paymentType.id,
                    label: `[${paymentType?.order_shop?.title}] ${paymentType?.title}`,
                  }))}
                  value={selectedPaymentType}
                  onChange={(value) => {
                    setSelectedPaymentType(value);
                    setTimeout(onFilter, 0);
                  }}
                />
              </div>
            </div>
          </TableFilterBox>
          <div>
            <ContentValidation loader={loadingPaymentGroups} array={groupData}>
              <div className="table-responsive">
                <TableUi
                  ths={["Group name", "Method of payment", ""]}
                  total={valuePaymentGroups?.data?.length || 0}
                >
                  {getFilteredData()?.map((data, index) => (
                    <TableUi.tr key={index}>
                      <TableUi.td>
                        <div style={{ paddingLeft: 15 }}>
                          <p className="group-title">{data?.title}</p>
                        </div>
                      </TableUi.td>
                      <TableUi.td>
                        <div
                          className="d-flex flex-row flex-wrap gap-1"
                          style={{ paddingTop: 15, marginBottom: 15 }}
                        >
                          {data?.payments?.map((item, i) => (
                            <div
                              className="borderder-component-text-grey d-flex flex-row"
                              key={i}
                            >
                              <p className="mr-1">{`[${item?.order_shop}] `}</p>
                              <p>{item?.title}</p>
                            </div>
                          ))}
                        </div>
                      </TableUi.td>
                      <TableUi.td>
                        <div
                          className="d-flex flex-row gap-1 justify-content-end"
                          style={{ marginRight: 15 }}
                        >
                          <ButtonEditRow
                            onClick={() => setModalOpt("edit", data.id)}
                          />
                          <ButtonDelete
                            onDelete={() => mutationDelete.mutate(data.id)}
                          />
                        </div>
                      </TableUi.td>
                    </TableUi.tr>
                  ))}
                </TableUi>
              </div>
            </ContentValidation>
          </div>
        </ContentBlock>
        {modalOpt?.type && (
          <ModalNewGroup
            modalOpt={modalOpt}
            onClose={closeModal}
            selectedPaymentType={valuePaymentGroups.data}
            parentCarriers={carriers}
          />
        )}
      </Container>
    </QueryClientProvider>
  );
}

const ModalNewGroup = ({ modalOpt, onClose, selectedPaymentType }) => {
  const [searchTitle, setSearchTitle] = useState("");
  const { value } = useFetch(
    `/api/v1/payment_types?q[title_cont_any]=${searchTitle}`
  );

  const [form] = Form.useForm();

  const mutationPost = useMutation({
    mutationFn: (newData) =>
      Axios({
        url: `/api/v1/payment_groups`,
        method: "POST",
        data: newData,
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  const mutationPut = useMutation({
    mutationFn: (updatedData) =>
      Axios({
        url: `/api/v1/payment_groups/${modalOpt.record_id}`,
        method: "PUT",
        data: { payment_group: updatedData },
      }).then((res) => res.data),
    onSuccess: () => {
      antdMessageSuccess();
      onClose();
    },
    onError: (error) => {
      antdMessageError(error?.response?.data?.message);
    },
  });

  useEffect(() => {
    if (modalOpt.type === "edit") {
      const editingGroup = selectedPaymentType.find(
        (group) => group.id === modalOpt.record_id
      );
      if (editingGroup) {
        form.setFieldsValue({
          title: editingGroup.title,
          pickup_address_ids: editingGroup.payments.map((payment) => ({
            key: payment.id,
            label: `[${payment.order_shop}] ${payment.title}`,
          })),
        });
      }
    }
  }, [modalOpt, form]);

  const filterPaymentTypes = (payments) => {
    if (modalOpt.type === "new_group") {
      return payments.filter(
        (payment) =>
          !selectedPaymentType.some((type) =>
            type.payment_ids.map(String).includes(payment.id?.toString())
          )
      );
    } else {
      return payments.filter(
        (payment) =>
          !selectedPaymentType.some(
            (type) =>
              type.id !== modalOpt.record_id &&
              type.payment_ids.includes(payment.id?.toString())
          )
      );
    }
  };

  return (
    <ModalSimple
      text={modalOpt.type === "edit" ? "Edit group" : "Create new group"}
      onClose={onClose}
      hide={true}
    >
      <Form
        form={form}
        layout="vertical"
        name="basic"
        onFinish={(values) => {
          const newCarrierIds = values.pickup_address_ids.map(
            (carrier) => carrier.key
          );

          const transformedValues = {
            title: values.title,
            payment_ids: newCarrierIds,
          };

          if (modalOpt.type === "edit") {
            mutationPut.mutate(transformedValues);
          } else {
            mutationPost.mutate(transformedValues);
          }
        }}
        autoComplete="off"
      >
        <Form.Item
          label="Group name"
          name="title"
          rules={[
            {
              required: true,
              message: "Please input your group name!",
            },
          ]}
        >
          <Input placeholder="Type in" />
        </Form.Item>

        <Form.Item
          label="Payment method"
          name="pickup_address_ids"
          rules={[
            {
              required: true,
              message: "Please select!",
            },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select"
            labelInValue
            showSearch
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            onSearch={(value) => setSearchTitle(value)}
          >
            {filterPaymentTypes(value?.data || []).map(
              ({ title, id, order_shop }) => (
                <Select.Option key={id} value={id}>
                  {`[${order_shop?.title}] ${title}`}
                </Select.Option>
              )
            )}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button className="w-100" type="primary" htmlType="submit">
            {modalOpt.type === "edit" ? "Update" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </ModalSimple>
  );
};
